import React from "react";

const ContentEmpty = ({ wishlistEmptyText }) => {
    return (
        <div class="side-panel-content-wrapper">
            <div
                dangerouslySetInnerHTML={{ __html: `${wishlistEmptyText}` }}
            ></div>
        </div>
    );
};

export default ContentEmpty;



// WEBPACK FOOTER //
// ./src/modules/ContentEmpty.js